import db from '@/database'

export default {
  beforeRouteUpdate (to, from, next) {
    next()

    for (let key in this.$firebaseRefs) {
      const asArray = Array.isArray(this[key])
      this.$unbind(key)

      if (asArray) {
        this.$bindAsArray(key, db.ref(this.refs[key]))
      } else {
        this.$bindAsObject(key, db.ref(this.refs[key]))
      }
    }
  }
}
